<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'住院费用'" :fixed="true"> </Nav>
    </div>
    <!-- 显示病人信息 -->
    <div class="info_backgroud">
      <div class="info">
        <span class="bold_font">{{ ClientName }}</span>
        <span class="sm_font hui_font">{{ InPatientId }}</span>
      </div>
      <div class="info_container">
        <div>
          <div>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-jine"></use></svg
            ><span class="sm_font hui_font">住院总费用</span>
          </div>

          <span class="bold_font">￥{{ expenses }}</span>
        </div>
        <div>
          <div>
            <span class="sm_font hui_font">入院时间：</span
            ><span class="time sm_font">{{ BeginDate }}</span>
          </div>
          <span class="deptName">{{ DeptName }}</span>
        </div>
      </div>
    </div>
    <div class="cell_backgrouod">
      <van-cell
        v-if="expenseDetails.length == 0"
        value="暂无信息"
        class="cell"
      ></van-cell>
      <van-cell
        v-for="(item, index) in expenseDetails"
        :key="index"
        class="cell"
        @click="detali"
      >
        <!-- 使用 title 插槽来自定义标题 -->
        <template #title>
          <span class="bold_font">{{ item.category }}</span>
          <span class="sm_font badge">合计</span>
          <span class="bold_font blue_fomt">{{ item.expense }}</span>
        </template>
        <!-- 使用 default 插槽来自定义右侧内容 -->
        <template #default>
          <div class="select">
            <span class="sm_font hui_font">查看明细</span>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-bofang"></use>
            </svg>
          </div>
        </template>
      </van-cell>
    </div>
  </div>
</template>
<script>
import "../../../common/expenses_iconfont.js";
import Nav from "@/components/nav.vue";
/* 引入vant单元格 */
import Vue from "vue";
import { Cell, CellGroup } from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  data() {
    return {
      ClientName: "",
      InPatientId: "",
      BeginDate: "",
      DeptName: "",
      expenseDetails: [],
    };
  },
  components: {
    Nav,
  },
  computed: {
    expenses: function () {
      var sum = 0;
      this.expenseDetails.forEach((item) => {
        sum = this.undefinedAdd(sum, item.expense);
      });
      return sum;
    },
  },
  methods: {

    detali(){
      this.$router.push({
        path: "/hospitalization_detail_C_a",
        query: {
          InPatientId: this.InPatientId,
          EndDate: this.EndDate,
          BeginDate: this.BeginDate,
        },
      });
    },
    undefinedAdd(x, y) {
      if (x == undefined) return y;
      x = new Number(x);
      y = new Number(y);
      x = x + y;
      return parseFloat(x.toFixed(2));
    },

    async init() {
      try {
        this.$showLoad();
        let R_data = {
          inPatientId: this.InPatientId,
          beginDate: this.BeginDate,
          endDate: this.EndDate,
        };
        //注册
        let zc_url = "/queryinpatientdailylist";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          zc_url,
          "POST",
          R_data,
          (data) => {
            var infolist = data.data.data.data;
            this.expenseDetails = [];
            if (Object.keys(infolist).length != 0) {
              /* 首先要知道一共有哪些类型的药费 */
              var expenseType = {};
              for (let index in infolist) {
                infolist[index].forEach((item) => {
                  if (item.tradeFlag == "1") {
                    expenseType[item.feeTypeName] = this.undefinedAdd(
                      expenseType[item.feeTypeName],
                      item.fee
                    );
                  }
                });
              }
              for (var key in expenseType) {
                this.expenseDetails.push({
                  category: key,
                  expense: expenseType[key],
                });
              }
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("注册并绑定失败, 请核对信息重试");
      }
    },
  },

  mounted() {
    if (this.$route.query) {
      this.InPatientId = this.$route.query.InPatientId;
      this.BeginDate = this.$route.query.BeginDate;
      this.EndDate = this.$route.query.EndDate;
      this.DeptName = this.$route.query.DeptName;
      this.ClientName = this.$route.query.ClientName;
    }
    this.init();
  },
};
</script>
<style scoped>
.main{
 background-color:  #f1f1f1;
  height: 100vh;
}
.nav {
  height: 6vh;
}

.info_backgroud {
  background-color: white;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.select {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.select > span {
  margin-right: 5px;
}
.info,
.info_container > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 10px 10px 10px;
}
.info {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 10px;
  padding-top: 10px;
}
.cell_backgrouod {
  padding: 10px;
}
.cell {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  border-radius: 5px;
}
.badge {
  color: white;
  background-color: rgb(223, 20, 20);
  padding: 2px 4px;
  border-radius: 10px;
  margin: 0px 5px;
}
.deptName {
  font-size: 10px;
  color: #007aff;
  border: 1px solid #007aff;
  padding: 3px 5px;
  border-radius: 10px;
}
.time {
  color: #9d9d9d;
}
.blue_fomt {
  color: #007aff;
}
.bold_font {
  font-weight: bold;
}
.sm_font {
  font-size: 10px;
}
.hui_font {
  color: #dcdcdc;
}
.info_container > div {
  display: flex;
  justify-content: space-between;
}
.info_container {
  display: flex;
  flex-direction: column;
}
</style>